import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './EventTeaser.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

function formatPrice(price) {
  if (!price) return null;
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(price);
}

const statusLabel = {
  upcoming: 'Segera',
  sold_out: 'Sold Out',
  past: 'Selesai',
};

export default function EventTeaser({ eyebrow = 'Live & Event', title = 'Jadwal Terdekat' }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/events/upcoming`)
      .then((res) => {
        if (mounted) setEvents(res.data.data || []);
      })
      .catch(() => {
        if (mounted) setError(true);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="event-teaser reveal">
      <div className="event-teaser__header">
        <span className="event-teaser__eyebrow">{eyebrow}</span>
        <h2 className="event-teaser__title">{title}</h2>
      </div>

      {loading && <div className="event-teaser__empty">Memuat event...</div>}

      {!loading && error && (
        <div className="event-teaser__empty">Gagal memuat event. Coba lagi nanti.</div>
      )}

      {!loading && !error && events.length === 0 && (
        <div className="event-teaser__empty">
          Belum ada event mendatang. Stay tuned!
        </div>
      )}

      {!loading && !error && events.length > 0 && (
        <div className="event-teaser__grid">
          {events.map((ev, i) => (
            <a
              href={`/events/${ev.id}`}
              className="event-card"
              key={ev.id}
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="event-card__poster">
                {ev.poster_url ? (
                  <img src={ev.poster_url} alt={ev.title} loading="lazy" />
                ) : (
                  <div className="event-card__poster-fallback" />
                )}
                <span className={`event-card__badge event-card__badge--${ev.status}`}>
                  {statusLabel[ev.status] || ev.status}
                </span>
              </div>
              <div className="event-card__body">
                <h3 className="event-card__title">{ev.title}</h3>
                <p className="event-card__meta">
                  {formatDate(ev.event_date)} · {ev.city}
                </p>
                {formatPrice(ev.starting_price) && (
                  <p className="event-card__price">
                    Mulai {formatPrice(ev.starting_price)}
                  </p>
                )}
              </div>
            </a>
          ))}
        </div>
      )}

      <a href="/events" className="event-teaser__cta">
        Lihat Semua Event →
      </a>
    </section>
  );
}
